// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_wrapper__YaRd9","iconWrapper":"Card_iconWrapper__wnsPV","image":"Card_image__iPgJG"};